import React, { Fragment, memo, useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { createAsyncAction } from 'src/utils/reduxUtils'
import { FetchMCLiteRelations } from 'src/constants/actionTypes'
import { ContractorDetails } from 'src/interfaces/contractor'
import { MCLiteAssignToDataRow } from '../mc-lite/MCLiteAssignToDataRow'
import { MCLiteRelation } from 'src/interfaces/mcLite'
import { MCLiteAssignedSubcontractorsDataRow } from '../mc-lite/MCLiteAssignedSubcontractorsDataRow'

interface MCLiteRowsProps {
  contractorDetails: ContractorDetails
  onUpdate(): void | Promise<void>
}

const MCLiteRowsComponent = ({ contractorDetails, onUpdate }: MCLiteRowsProps) => {
  const dispatch = useDispatch()

  const [mcLiteRelations, setMcLiteRelations] = React.useState<MCLiteRelation | null>(null)

  const fetchMCLiteRelations = useCallback(async () => {
    try {
      const relations: MCLiteRelation = await createAsyncAction(
        dispatch,
        FetchMCLiteRelations.request({ contractorId: contractorDetails.id }),
      )

      setMcLiteRelations(relations)
    } catch {}
  }, [dispatch, contractorDetails.id])

  useEffect(() => {
    fetchMCLiteRelations()
  }, [fetchMCLiteRelations])

  const handleMCLiteRefresh = useCallback(async () => {
    await fetchMCLiteRelations()
    await onUpdate()
  }, [fetchMCLiteRelations, onUpdate])

  const showMcLiteRows = !!mcLiteRelations

  return (
    <Fragment>
      {showMcLiteRows && (
        <MCLiteAssignToDataRow
          contractorId={contractorDetails.id}
          currentTemplateId={contractorDetails.collectDataTemplateId}
          assignedTo={mcLiteRelations.mcLite}
          isNotAllowed={Boolean(mcLiteRelations.subcontractors.length)}
          onRefresh={handleMCLiteRefresh}
        />
      )}
      {showMcLiteRows && (
        <MCLiteAssignedSubcontractorsDataRow
          contractorId={contractorDetails.id}
          assignedSubcontractors={mcLiteRelations.subcontractors}
          isNotAllowed={Boolean(mcLiteRelations.mcLite)}
          onRefresh={handleMCLiteRefresh}
        />
      )}
    </Fragment>
  )
}

export const MCLiteRows = memo(MCLiteRowsComponent)
